import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import React, { Component } from 'react'
import { i18n } from '../../index'
import css from './openingTime.css'
import type { OpeningTimeType } from './types'

const getDisplayTime = (time = ''): string => {
  const [hour, minute] = time.split(':')
  return `${hour}.${minute}`
}

const processOpeningTime = (openingTime) => {
  let { endTime } = openingTime
  if (endTime === '00:00:00') endTime = '24:00:00'
  return { ...openingTime, endTime }
}

const OpeningTime = ({ openingTime }) => {
  const { weekDay, startTime, endTime } = openingTime
  return (
    <TableRow className={css.openingTime}>
      <TableCell>{i18n.t(`weeklyInfo.heading.weekday${weekDay}`)}</TableCell>
      <TableCell align='right'>
        {getDisplayTime(startTime)} - {getDisplayTime(endTime)}
      </TableCell>
    </TableRow>
  )
}

type Props = {
  openingTimes: Array<OpeningTimeType>
}
export default class OpeningTimes extends Component<Props> {
  render() {
    const { openingTimes = [] } = this.props
    return (
      <Table className={css.openingTimesTable}>
        <TableHead>
          <TableRow>
            <TableCell>{i18n.t(`admin.stations.label.weekday`)}</TableCell>
            <TableCell align='right'> {i18n.t(`admin.stations.label.openingTime`)}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {openingTimes.map((openingTime, i) => (
            <OpeningTime key={i} openingTime={processOpeningTime(openingTime)} />
          ))}
        </TableBody>
      </Table>
    )
  }
}
